import { Component } from '@angular/core';
import { IonicPage, NavController,AlertController,ActionSheetController, LoadingController, NavParams } from 'ionic-angular';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CommonProvider } from '../../providers/common/common';
import {GenericFormValidationProvider} from "../../providers/common/form-validation"


/**
 * Generated class for the ReferAFriendPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-refer-a-friend',
  templateUrl: 'refer-a-friend.html',
})
export class ReferAFriendPage {
  model:any={};
  productList:any=[];
  dailingCodes:any=[];
  errorDisplay:any={}
   



  constructor(private fv : GenericFormValidationProvider,public loadingCtrl: LoadingController,private cp: CommonProvider,
    public navCtrl: NavController, public navParams: NavParams,public actionSheetCtrl: ActionSheetController) {
    this.model.lead={};
  }

  ionViewDidLoad() {
    this.model.lead={};
    this.model.lead.ibhfl_leadsourceid="REFERRAL";
    
   this.getDailingCodeAllCountry();
   this.getProductList();
  }
  presentActionSheet(msg) {
      const actionSheet = this.actionSheetCtrl.create({
        title: msg,
        cssClass: 'commanSheet',
        buttons: [
          {
            text: "OK",
            role: 'Ok',
            handler: () => {
              this.getDailingCodeAllCountry()
               actionSheet.dismiss();
            }
          }
        ]
      });
      actionSheet.present();
    }
  getDailingCodeAllCountry(){
    let loading = this.loadingCtrl.create({
      content: 'Please wait...'
    });
    loading.present();
    let data = this.cp.getDailingCodeAllCountries(loading) ;
    data.then((res:any)=>{
       loading.dismiss();
      this.dailingCodes=JSON.parse(res).Payload.ibhfl_countrydialingcodes;
      this.model.lead.your_country_code1 = this.dailingCodes[0].ibhfl_name;
      this.model.lead.your_country_code = this.dailingCodes[0].ibhfl_name;
      // this.country_code=this.dailingCodes[0].ibhfl_name;
    })
   
    
  }
  getProductList(){
    let loading = this.loadingCtrl.create({
      content: 'Please wait...'
    });
    loading.present();
    let data = this.cp.getRefferAfriendPage(loading) ;
    data.then((res:any)=>{
       loading.dismiss();
       //console.log("Product list of the refer",JSON.parse(res));
      this.productList=JSON.parse(res).Payload.products;
      this.model.lead.ibhfl_purposeproduct=this.productList[0].productnumber;
      // this.country_code=this.dailingCodes[0].ibhfl_name;
    })

  }
  postFormForValidation(){
      this.errorDisplay=this.fv.checkValidationFormAllControls(document.forms[0],true,[]);
      
      if(this.errorDisplay.valid){
        return false;
      }else{

        delete this.model.lead.your_country_code;
        delete this.model.lead.your_country_code1
        ////console.log(this.model);
        
        let loading = this.loadingCtrl.create({
            content: 'Please wait...'
          });
          loading.present()
          this.cp.referAFriends(loading,this.model).then((res:any)=>{
            loading.dismiss()
            var res=JSON.parse(res)
             this.presentActionSheet("Your has been submitted successfully.")
             
          })
      }
  }

}



// WEBPACK FOOTER //
// ./src/pages/refer-a-friend/refer-a-friend.ts